<template>
<div class=" sa-no-data">
    <img src="../../assets/img/no-data-found.svg" alt="No Data Found" class="sa-img-responsive" />
    <h2><strong>No Data Found</strong></h2>
    <!-- <p>Maybe because the page you are looking for is still in draft state or isnt published at all. For more information on what exactly went wrong. <span class="d-block">Please contact the form's adminstrator.</span></p> -->
</div>
</template>
<script>
  export default {
    data() {
      return {
      };
    }
  };
</script>